// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { specificationsStyles } from "@rpsc/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import { avoidBreakInsidePrintElement, color } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

specificationsStyles.title = {
    variant: "h3",
    forwardAs: "p",
    css: css`
        margin: 0;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 8px;
        margin-bottom: 12px;
    `,
};

specificationsStyles.listTab = {
    mergeCss: true,
    cssOverrides: {
        tabGroup: css`
            @media print {
                display: none;
            }
        `,
        tabContent: css`
            margin-top: 16px;
            @media print {
                display: none;
            }
        `,
    },
};

specificationsStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 32px;
        @media print {
            display: none !important;
        }
    `,
};

specificationsStyles.tabsPrintWrapper = {
    css: css`
        display: none;
        @media print {
            display: block;
        }
    `,
};
specificationsStyles.tabPrintContentWrapper = {
    css: css`
        ${avoidBreakInsidePrintElement}
    `,
};
specificationsStyles.tabGroupTab = {
    mergeCss: true,
    typographyProps: {
        css: css`
            @media print {
                display: none;
            }
        `,
    },
};
